export const Variation = {
  DISPONIBLE: "disponible",
  NOT_DISPONIBLE: "not-disponible",
};